var ko = require('knockout');

function Message(params) {
  if (params === undefined) {
    throw 'Error: Message component requires parameters to be passed to it.';
  }
  if (
    params.type === undefined ||
    params.isOpen === undefined ||
    params.message === undefined
  ) {
    throw 'Error: Message requires the following parameters to be defined: type, isOpen, message.';
  }
  if (
    !ko.isObservable(params.type) ||
    !ko.isObservable(params.isOpen) ||
    !ko.isObservable(params.message)
  ) {
    throw 'Error: Message component requires the following parameters to be observables: type, isOpen, message.';
  }

  this.type = params.type;
  this.extraClassNames = ko.observable(ko.unwrap(params.extraClassNames));
  this.message = params.message;

  this.isOpen = params.isOpen;
}

Message.prototype.close = function() {
  this.isOpen(false);
};

module.exports = Message;
